//-------------------------------------------------------------------
const getFilteredPrices = (priceList, limitDate, range) => {
  // Exception for 5D range, product wants to show 5 days, not 5 natural days
  if (range === 5) return priceList.slice(-5)

  return priceList.filter(price => new Date(price.dt) >= limitDate)
}

//-------------------------------------------------------------------
export const generateData = (range, currency, prices, locale) => {
  const newTableData = {
    prices: [],
    ticks: [],
  }
  const today = new Date()
  const _range = range === "YTD" ? (today.getMonth() + 1) * 31 : parseInt(range)
  const limitDate = new Date(new Date().setDate(today.getDate() - _range))
  const monthlyTick = range === "YTD" || range > 30

  let filteredPrices = getFilteredPrices(
    prices.priceList["daily"],
    limitDate,
    _range
  )

  let lastMonth = -1
  for (let d = 0; d < filteredPrices.length; d++) {
    const price = filteredPrices[d]
    const date = new Date(price.dt)

    let diff = 0.0
    if (d > 0) {
      const prevPrice = filteredPrices[d - 1][currency]
      diff = (price[currency] - prevPrice) / prevPrice
    }

    newTableData.prices.push({
      dt: price.dt,
      price: price[currency],
      diff,
    })

    if (monthlyTick) {
      const month = date.getMonth()
      if (month != lastMonth) {
        lastMonth = month
        newTableData.ticks.push(price.dt)
      }
    } else {
      newTableData.ticks.push(price.dt)
    }
  }

  return newTableData
}
